import EnquiriesLinesForm from '../../../../components/Sales/Enquiries/Lines/EnquiriesLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function EnquiriesLinesModal (props) {
  const { remove, submit, update, visible, modalType, formRef, onCancel, removing, submitting } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Enquiries Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <EnquiriesLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

EnquiriesLinesModal.propTypes = {}
EnquiriesLinesModal.defaultProps = {}

export default EnquiriesLinesModal
